// AIDEV-NOTE: Formula Haversine — calcula distancia em metros entre duas coordenadas GPS

const EARTH_RADIUS_M = 6371000;

export function haversineDistance(lat1: number, lng1: number, lat2: number, lng2: number): number {
  const toRad = (v: number) => (v * Math.PI) / 180;
  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_M * Math.asin(Math.sqrt(a));
}

export function estaProximo(
  userLat: number,
  userLng: number,
  targetLat: number,
  targetLng: number,
  raioMetros = 200
): boolean {
  return haversineDistance(userLat, userLng, targetLat, targetLng) <= raioMetros;
}
